/* koma-nav.js
   1. Boutique ouvert a chaque ouverture du tiroir, refermable librement.
   2. Bulles equipe sous le titre du formulaire de contact.
   3. Bloc d appel vers le quiz, en bas de la page d accueil.

   REGLE DE COPY : avant le resultat du quiz, aucune mention d un produit
   koma. Le questionnaire doit se presenter comme une recherche neutre du
   bon oreiller. Le CloudForm n apparait qu une fois les dix reponses
   donnees, comme conclusion et non comme point de depart.
*/
(function () {
  /* ================================================================
     1. TIROIR : Boutique ouvert par defaut
     On ecoute l evenement toggle du tiroir lui meme, jamais les clics
     internes, sinon le clic servant a refermer Boutique la rouvrirait.
     ================================================================ */
  var LABEL = 'boutique';

  function findBoutique() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return null;
    var items = drawer.querySelectorAll('details');
    for (var i = 0; i < items.length; i++) {
      var summary = items[i].querySelector('summary');
      if (!summary) continue;
      if ((summary.textContent || '').trim().toLowerCase().indexOf(LABEL) === 0) return items[i];
    }
    return null;
  }

  function openBoutique() {
    var d = findBoutique();
    if (!d || d.open) return;
    var s = d.querySelector('summary');
    if (s) s.click();
  }

  function initDrawer() {
    openBoutique();
    var container = document.querySelector('.menu-drawer-container');
    if (!container) return;
    container.addEventListener('toggle', function () {
      if (container.open) setTimeout(openBoutique, 60);
    });
  }

  /* ================================================================
     2. PAGE CONTACT : bulles equipe
     Dans un template JSON, Shopify ne rend pas l identifiant de section
     tel quel : contact_form_U9ptC4 devient dans le DOM
     shopify-section-template--123456__contact_form_U9ptC4.
     On cible donc par suffixe, jamais par egalite.
     ================================================================ */
  var TEAM = [
    'https://cdn.shopify.com/s/files/1/1035/8505/5060/files/equipe1.jpg?v=1786826804&width=200',
    'https://cdn.shopify.com/s/files/1/1035/8505/5060/files/Equipe2.jpg?v=1786826641&width=200',
    'https://cdn.shopify.com/s/files/1/1035/8505/5060/files/Equipe3.jpg?v=1786826667&width=200',
    'https://cdn.shopify.com/s/files/1/1035/8505/5060/files/Equipe4.jpg?v=1786826689&width=200',
    'https://cdn.shopify.com/s/files/1/1035/8505/5060/files/Equipe5.jpg?v=1786827940&width=200'
  ];

  function buildBubbles() {
    var wrap = document.createElement('div');
    wrap.className = 'koma-team-bubbles';
    for (var i = 0; i < TEAM.length; i++) {
      var img = document.createElement('img');
      img.src = TEAM[i];
      img.alt = '';
      img.setAttribute('role', 'presentation');
      img.loading = 'lazy';
      wrap.appendChild(img);
    }
    return wrap;
  }

  function findContactSection() {
    var s = document.querySelector('[id^="shopify-section"][id$="contact_form_U9ptC4"]');
    if (s) return s;
    var forms = document.querySelectorAll('form[action*="/contact"]');
    for (var i = 0; i < forms.length; i++) {
      var t = forms[i].querySelector('input[name="form_type"]');
      if (t && t.value === 'contact' && forms[i].closest) {
        var p = forms[i].closest('[id^="shopify-section"]');
        if (p) return p;
      }
    }
    return null;
  }

  function injectTeamBubbles() {
    if (document.querySelector('.koma-team-bubbles')) return true;
    var section = findContactSection();
    if (!section) return false;
    var anchor =
      section.querySelector('.title-wrapper-with-link') ||
      section.querySelector('.title') ||
      section.querySelector('h1, h2, h3');
    if (anchor) { anchor.insertAdjacentElement('afterend', buildBubbles()); return true; }
    var form = section.querySelector('form');
    if (form) { form.insertAdjacentElement('beforebegin', buildBubbles()); return true; }
    return false;
  }

  /* ================================================================
     3. ACCUEIL : bloc d appel vers le quiz
     Le template d accueil est trop volumineux pour etre reecrit sans
     risque, on insere donc le bloc en fin de contenu principal, juste
     avant le pied de page. Pour le remonter plus haut, faire glisser
     la section "Quiz oreiller koma" dans l editeur de theme.
     Aucun nom de produit dans ce bloc, voir la regle de copy en tete.
     ================================================================ */
  var QUIZ_URL = '/pages/quel-oreiller';

  function isHome() {
    var p = window.location.pathname.replace(/\/+$/, '');
    return p === '' || /^\/[a-z]{2}(-[a-z]{2})?$/i.test(p);
  }

  function injectQuizBanner() {
    if (!isHome()) return true;
    if (document.querySelector('.koma-quiz-cta')) return true;

    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return false;

    if (!document.getElementById('koma-quiz-cta-style')) {
      var st = document.createElement('style');
      st.id = 'koma-quiz-cta-style';
      st.textContent =
        '.koma-quiz-cta{background:#E9E6F9;padding:4.4rem 2rem;text-align:center}' +
        '.koma-quiz-cta__in{max-width:620px;margin:0 auto;color:#453C8F}' +
        '.koma-quiz-cta__k{font-size:1.2rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#F2917E;margin:0 0 1rem}' +
        '.koma-quiz-cta__h{font-size:2.8rem;line-height:1.25;font-weight:700;margin:0 0 1.2rem;color:#453C8F}' +
        '.koma-quiz-cta__p{font-size:1.6rem;line-height:1.6;margin:0 0 2.4rem;opacity:.8}' +
        '.koma-quiz-cta__b{display:inline-block;padding:1.5rem 3.4rem;border-radius:999px;background:#453C8F;' +
        'color:#fff !important;text-decoration:none !important;font-weight:700;font-size:1.65rem;' +
        'transition:transform .15s ease,background .15s ease}' +
        '.koma-quiz-cta__b:hover{background:#F2917E;transform:translateY(-2px)}' +
        '@media screen and (max-width:749px){.koma-quiz-cta{padding:3.4rem 1.6rem}.koma-quiz-cta__h{font-size:2.2rem}}';
      document.head.appendChild(st);
    }

    var sec = document.createElement('section');
    sec.className = 'koma-quiz-cta';
    sec.innerHTML =
      '<div class="koma-quiz-cta__in">' +
      '<p class="koma-quiz-cta__k">En 2 minutes</p>' +
      '<p class="koma-quiz-cta__h">Quel oreiller vous faut-il vraiment ?</p>' +
      '<p class="koma-quiz-cta__p">Dix questions sur votre morphologie, votre couchage et vos habitudes de sommeil. À la fin, vous saurez quelle hauteur et quel type de soutien correspondent à votre profil.</p>' +
      '<a class="koma-quiz-cta__b" href="' + QUIZ_URL + '">Faire le test</a>' +
      '</div>';

    main.appendChild(sec);
    return true;
  }

  /* ================================================================ */
  function init() {
    initDrawer();
    var ok1 = injectTeamBubbles();
    var ok2 = injectQuizBanner();
    if (!ok1 || !ok2) {
      setTimeout(function () { injectTeamBubbles(); injectQuizBanner(); }, 400);
      setTimeout(function () { injectTeamBubbles(); injectQuizBanner(); }, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
